module.exports = __webpack_public_path__ + "static/media/storage-showcase.7b39ee58.webm";